export const environment = {
  production: false,
  urlEdducaImobApi: 'https://hml.api.edducaimob.com.br/',
  urlBase: 'https://hml.edducaimob.com.br'
};
